/**
 * author: Ananthapadmanabhan V K
 */
import React from "react";
import { Route, Navigate  } from "react-router-dom";
const SuperAdminRoute = ({ children }) => {
    const authed = isauth();
    return authed ? children : <Navigate to="/login" />;
  }

function isauth() {
    var accessToken = localStorage.getItem('accessToken');
    if(accessToken !=null && accessToken!==undefined && accessToken!=='') {
        return true;
    } else {
        return false;
    }
  }

export default SuperAdminRoute;